export class UploadQueue {
  #queue = []
  #activeUploads = 0
  #totalFiles = 0
  #completedFiles = 0

  reset() {
    this.#queue = []
    this.#activeUploads = 0
    this.#totalFiles = 0
    this.#completedFiles = 0
  }

  addFiles(files) {
    const validFiles = files.filter(file => file instanceof File)
    this.#totalFiles += validFiles.length

    validFiles.forEach(file => {
      this.#queue.push({
        file,
        tempId: `upload-${crypto.randomUUID()}`
      })
    })
  }

  getNext() {
    if (this.#queue.length === 0) return null

    const item = this.#queue.shift()
    this.#activeUploads++
    return item
  }

  canProcessMore(batchSize) {
    return this.#activeUploads < batchSize && this.#queue.length > 0
  }

  recordCompletion() {
    if (this.#activeUploads > 0) {
      this.#activeUploads--
    }
    this.#completedFiles++
  }

  isComplete() {
    return this.#queue.length === 0 && this.#activeUploads === 0
  }

  getProgress() {
    return {
      completed: this.#completedFiles,
      total: this.#totalFiles,
      active: this.#activeUploads,
      remaining: this.#queue.length
    }
  }

  isEmpty() {
    return this.#queue.length === 0
  }

  hasActiveUploads() {
    return this.#activeUploads > 0
  }
}
